__turbopack_context__.v({
  "container": "wYpLnq_container",
  "containerWeb3Theme": "wYpLnq_containerWeb3Theme",
  "cta": "wYpLnq_cta",
  "ctaLink": "wYpLnq_ctaLink",
  "grid": "wYpLnq_grid",
  "heading": "wYpLnq_heading",
  "image": "wYpLnq_image",
  "noPaddingTitle": "wYpLnq_noPaddingTitle",
  "paragraph": "wYpLnq_paragraph",
  "paragraphwithQuote": "wYpLnq_paragraphwithQuote",
  "quote": "wYpLnq_quote",
  "title": "wYpLnq_title",
  "ul": "wYpLnq_ul",
});
